module.exports = __webpack_public_path__ + "img/energia_electrica_nivel1.39553da9.jpg";